import HttpService from '../../system/services/HttpService'

export default {
    userInfo: (student_id) => {
        return HttpService.get('/interactionSite/users/' + student_id)
    }
};
